export * from './entity-detail-layout.component';
